import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KzMeshLinkComponent } from './mesh-link/kz-mesh-link.component';
import { KzButtonModule } from '../form/button/kz-button.module';
import { KzIconsModule } from '../icon/kz-icons.module';
import { KzMeshLinkContainerComponent } from './kz-mesh-link-container.component';

@NgModule({
  declarations: [
    KzMeshLinkComponent,
    KzMeshLinkContainerComponent,
  ],
  exports: [
    KzMeshLinkComponent,
    KzMeshLinkContainerComponent,
  ],
  imports: [
    CommonModule,
    KzButtonModule,
    KzIconsModule,
  ]
})
export class KzMeshLinkModule { }
